<template>
	<TheBox :title="complaint.title" :titleLevel="3" :insideTable="true">
		<el-row class="flex flex--justifyspacebetween">
			<span>
				{{ complaint.category ? $recursivelyFindCategoryName(complaint.category.number) : '-' }}
			</span>
			<span v-if="complaint.publishedDate">
				{{ $formatDate(complaint.publishedDate) }}
			</span>
		</el-row>

		<div class="button-panel">
			<TheButton type="default" @buttonclick="goToDetailPage(complaint)">Details zur Beschwerde</TheButton>
		</div>
	</TheBox>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ComplaintResponse } from '../../types/types';
import TheBox from '../TheBox.vue';
import TheButton from '../TheButton.vue';

export default defineComponent({
	name: 'BoxComplaintPublic',
	data() {
		return {};
	},
	props: {
		complaint: {
			type: Object,
			required: true,
		},
	},
	components: {
		TheBox,
		TheButton,
	},
	methods: {
		goToDetailPage(row: ComplaintResponse) {
			this.$router.push({ name: 'BeschwerdeDetail', params: { id: String(row.id) } });
		},
	},
});
</script>
